<template>
    <div>
        <div class="header-order-tracking" v-bind:style="{backgroundColor : color_botones }">
			<div class="force-close">
				<i class="fas fa-chevron-left" @click="backToManagment()" v-if="formRestaurant"></i>
			</div>
			<h4>Seguimiento del pedido</h4>
			<h5>Número del pedido: {{ id_order }}</h5>
		</div>
        <br>
        <GmapMap
            :center='center'
            :zoom='16'
            style='width:100%;  height: 400px;'
            >
            <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="center=m.position"
            />
        </GmapMap>
    </div>
</template>

<style type="text/css" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

    .header-order-tracking{
        width: 100%;
        height: 20vh;
        padding: 0px 15px 0px 25px;
        text-align: left;
    }

    .header-order-tracking h4{
        margin-bottom: 0 !important;
        font-family: 'Poppins';
        color: #fff;
        font-weight: 500;
    }

    .header-order-tracking h5{
        margin-bottom: 0 !important;
        font-family: 'Poppins';
        color: #fff;
        font-size: 16px;
        font-weight: 500;
    }

    .force-close{
        width: 100%;
        text-align: left;
        padding-top: 15px;
    }

    .force-close i{
        color: #fff;
        font-size: 19px;
        cursor: pointer;
    }
</style>

<script>
    export default {
        props:['formRestaurant'],

        name: 'GoogleMap',

        data(){
			return{
                color_botones: localStorage.getItem('color_licencia'),
                center: { lat: 10.4558507, lng: -73.2441445 },
                socket: "",
                id_order: localStorage.getItem('id_order'),
                markers: [],
                data_test : {
                    latitude: 10.4558507, longitude: -73.2441445
                }
            }
        },

        methods: {
            backToManagment(){
				this.$emit('closeTracking',false);
			},

            saveSocketClient(){
                this.socket.emit("save-client-socket", this.id_order)
            },
            setupSocket(){
                var self = this;
                self.socket.on("order-tracking-delivery-position", (data)=> {
                    this.addMarker(data)
                })
            },
            addMarker(position_data) {
                this.markers = []
                const marker = {
                    lat: parseFloat(position_data.data.latitude),
                    lng: parseFloat(position_data.data.longitude),
                };
                this.markers.push({ position: marker })
                this.center = marker;
            },
        },

        mounted(){
            // this.addMarker(this.data_test)
            if (!this.formRestaurant) {
				$(".force-close").addClass("pt");
			}else{
				$(".force-close").removeClass("pt");
			}

            this.socket = io(`https://back.vinapp.co:3001`,{transports: ['websocket'], upgrade: false})
            this.saveSocketClient()
            this.setupSocket()
        }
    }
</script>